import { Modal, Stack, Text, Group, Button, Alert } from '@mantine/core';
import { AlertTriangle, Trash2 } from 'react-feather';
import type { GroupWithMembers } from '../../../services/api/groups';

interface DeleteGroupConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  group: GroupWithMembers | null;
  deleting?: boolean;
}

export function DeleteGroupConfirmModal({
  opened,
  onClose,
  onConfirm,
  group,
  deleting = false,
}: DeleteGroupConfirmModalProps) {
  if (!group) return null;

  const memberCount = group.members?.length ?? group.member_count ?? 0;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Delete Group"
      size="sm"
    >
      <Stack gap="md">
        <Text size="sm">
          Are you sure you want to delete <strong>&ldquo;{group.name}&rdquo;</strong>?
        </Text>

        <Text size="sm" c="dimmed">
          This action is final and cannot be undone.
        </Text>

        {memberCount > 0 && (
          <Alert
            icon={<AlertTriangle size={16} />}
            color="blue"
            variant="light"
          >
            <Text size="sm">
              {memberCount} participant{memberCount !== 1 ? 's' : ''} currently in this group will be moved to Unassigned and can be re-added to another group.
            </Text>
          </Alert>
        )}

        <Group justify="flex-end" gap="sm" mt="sm">
          <Button variant="default" onClick={onClose} disabled={deleting}>
            Cancel
          </Button>
          <Button
            color="red"
            leftSection={<Trash2 size={14} />}
            onClick={onConfirm}
            loading={deleting}
          >
            Delete Group
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

export default DeleteGroupConfirmModal;
